import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalTit: 0,
    qtdeTit: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    tipoTela: '',

    filtros: {
      tipoTela: 'TIT',
      buscaOrdem: { campo: 'tparc_data_parcela', ordem: 'DESC' },
    }

  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalTit: 0, qtdeTit: 0 });
    const { pagina, limite } = this.state;

    const { buscaOrdem } = this.state.filtros;

    // console.log('getListaRegistros');

    axios
      .get('/contratos/mensalidades', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          controle: '',
          numero: '',
          situacao: '',
          tit_idf_contrato: 0,
          dataIni: '',
          dataFim: '',
          tipoTela: 'MENSALIDADES',
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;

        // console.log('getListaRegistros: ', response.data);

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };



  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };





  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderValor = (tit_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(tit_vlr_total)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, formFiltroVisivel, salvando,
      registroSelecionado, filtros, total, pagina, limite } = this.state;

    // console.log('TitulosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Mensalidades</span>
        <div className="divider-page" />

        <Row>
          <div style={{ paddingTop: 0 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf)}
            >
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title={this.renderTitulo("Número")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title={this.renderTitulo("Data Vencimento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={150}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="tparc_valor"
                dataIndex="tparc_valor"
                title={this.renderTitulo("Valor Mensalidade")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={100}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_data"
                dataIndex="pgto_data"
                title={this.renderTitulo("Data Pagamento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={150}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_pago"
                dataIndex="pgto_vlr_pago"
                title={this.renderTitulo("Valor Pagamento")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={100}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="situacao_parcela"
                dataIndex="situacao_parcela"
                title={this.renderTitulo("Situação")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={100}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="."
                dataIndex="."
                title={this.renderTitulo(".")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={300}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/MensalidadesPage.js